<template>
    <div>
        <timezone-form></timezone-form>
        <teacher-bio></teacher-bio>
    </div>
</template>

<script>
import TimezoneForm from '../TimezoneForm.vue';
import TeacherBio from './TeacherBio.vue';

export default {
  components: { TimezoneForm, TeacherBio },

};
</script>

<style>

</style>
